'use client';

import { useTranslations } from 'next-intl';

interface PublicFooterProps {
  className?: string;
}

/**
 * PublicFooter Component
 *
 * Compact marketing footer for public pages (landing, auth, info, invite):
 * brand/copyright, safety badges, and a tagline.
 *
 * NOTE: the canonical LEGAL links (Terms, Privacy, Cookie settings, Imprint,
 * Contact) now live in the fleet-shared <LegalFooter> (@owlcat/app-shell),
 * mounted once in app/layout.tsx so they appear on EVERY portal page pointing at
 * the one canonical source (accounts). They were removed here to avoid a
 * duplicate, divergent legal row (this footer previously rendered portal-local
 * legal copy). Keep this footer marketing-only.
 */
export function PublicFooter({ className }: PublicFooterProps) {
  const t = useTranslations();
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="public-footer" className={`bg-muted/50 border-t border-border py-5 ${className ?? ''}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col gap-3">
          {/* Row 1: Copyright and Version */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <span className="text-xl">🦉🐱</span>
              <span>© {currentYear} OwlCat Club</span>
              <span className="hidden sm:inline">•</span>
              <span className="text-xs opacity-70">beta</span>
            </div>
          </div>

          {/* No badges, no tagline.
              "For children", "Safe" and "Made with ❤ for children's
              development" said nothing a visitor had asked and nothing the
              page had not already shown — three reassurances in a row read as
              a product that needs reassuring. The safety claims that mean
              something are on the page itself, with what they actually are. */}
        </div>
      </div>
    </footer>
  );
}
